import { Modal } from  '../../common/modal';
import KindleTroubleResponseTemplateBroken from '../templates/KindleTroubleResponseModalBroken.html';
import KindleTroubleResponseTemplateDevice from '../templates/KindleTroubleResponseModalDevice.html';
import KindleTroubleResponseTemplateOther  from '../templates/KindleTroubleResponseModalOther.html';

export default class KindleTroubleResponseModal extends Modal {
    constructor(option, alternativeFormatId){

        let alternativeButtonText = alternativeFormatId === 'odread'
            ? window.html('readNow')
            : `${window.html('accountLoans.download')} ${window.html(`formats.${alternativeFormatId}`)}`;

        let content, modalContents;
        switch (option) {
            case 'broken':
                content = KindleTroubleResponseTemplateBroken(alternativeButtonText);
                modalContents = {
                    classes: ['KindleTroubleResponseModal'],
                    title: window.html('kindleFulfillment.kindleTroubleResponseModal.thanks'),
                    content
                };
                break;
            case 'device':
                content = KindleTroubleResponseTemplateDevice(alternativeButtonText);
                modalContents = {
                    classes: ['KindleTroubleResponseModal'],
                    title: window.html('kindleFulfillment.kindleTroubleResponseModal.otherOptions'),
                    content
                };
                break;
            default :
                content = KindleTroubleResponseTemplateOther(alternativeButtonText);
                modalContents = {
                    classes: ['KindleTroubleResponseModal'],
                    title: window.html('contactSupport'),
                    content
                };
                break;
        }

        super(modalContents);

        this.$el.find('.confirm-button').on('click', () => {
            this.close();
        });
    }
}
